import { fmtMin, fmtTime } from "@/lib/format";
import { StatusBadge } from "@/components/common";
import { Button } from "@/components/ui/button";
import { History, RotateCcw, ShieldCheck } from "lucide-react";

export function DoneTaskRow({ t, isWorker, canManage, isManager, act, onAdminAction }) {
  const assignedNames = t.assigned_to_names || [];
  return (
    <div className="bg-card border border-border rounded-lg p-3 flex items-center justify-between gap-2" data-testid={`task-done-${t.task_id}`}>
      <div>
        <div className="flex items-center gap-2">
          <p className="text-sm font-medium capitalize">
            {t.type} <span className="metric text-primary">{t.task_id}</span> {t.bill_no && <span className="metric text-primary">· {t.bill_no}</span>}
          </p>
          <StatusBadge status={t.status} testid={`done-status-${t.task_id}`} />
        </div>
        <p className="text-xs text-muted-foreground metric">
          {fmtTime(t.start_time)} → {fmtTime(t.end_time)} · {fmtMin(t.active_minutes)}
          {t.standard_minutes ? ` (std ${t.standard_minutes}m)` : ""}
          {t.delay_minutes > 0 && <span className="text-signal-red font-bold"> +{Math.round(t.delay_minutes)}m late</span>}
        </p>
        {!isWorker && <p className="text-xs text-muted-foreground">{assignedNames.join(", ") || (t.required_role ? `Required role: ${t.required_role}` : "Unassigned")}</p>}
      </div>
      <div className="flex items-center gap-2">
        {t.verified_by ? (
          <span className="text-[10px] font-mono uppercase tracking-widest text-signal-green flex items-center gap-1"><ShieldCheck className="w-3.5 h-3.5" /> Verified</span>
        ) : (
          canManage && t.status === "completed" && (
            <Button size="sm" variant="outline" onClick={() => act(t.task_id, "verify")} data-testid={`verify-task-${t.task_id}`}>Verify</Button>
          )
        )}
        {canManage && onAdminAction && (
          <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => onAdminAction("history", t)} data-testid={`history-task-${t.task_id}`}>
            <History className="w-3 h-3 mr-1" /> History
          </Button>
        )}
        {isManager && t.status === "completed" && onAdminAction && (
          <Button size="sm" variant="ghost" className="h-7 text-xs text-signal-blue" onClick={() => onAdminAction("reopen", t)} data-testid={`reopen-task-${t.task_id}`}>
            <RotateCcw className="w-3 h-3 mr-1" /> Reopen
          </Button>
        )}
      </div>
    </div>
  );
}
